import types from '../types'
import Action from '../../types/Action'

const initialState = {
    resources: {
        loading: true,
        error: false,
        success: false,
        data: []
    }
}

const resourceReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case types.GET_RESOURCES_REQUESTED: {
            return {
                ...state,
                resources: {
                    loading: true,
                    error: false,
                    success: false,
                    data: []
                }
            }
        }
        case types.GET_RESOURCES_FULFILLED: {
            return {
                ...state,
                resources: {
                    ...state.resources,
                    loading: false,
                    success: true,
                    data: action.payload
                }
            }
        }
        case types.GET_RESOURCES_REJECTED: {
            return {
                ...state,
                resources: {
                    ...state.resources,
                    loading: false,
                    error: action.payload
                }
            }
        }
        default:
            return state
    }
}

export default resourceReducer